import get from 'lodash/get'
import {
  SEARCH_SAILOR_ASHORE_VISITS_FAILURE,
  SEARCH_SAILOR_ASHORE_VISITS_REQUEST,
  SEARCH_SAILOR_ASHORE_VISITS_SUCCESS,
  CLEAR_SAILOR_ASHORE_VISITS
} from '../constants/actionTypes'

export const initialSailorAshoreVisitReportsState = {
  reportItems: [],
  pageInfo: {},
  totalResults: 0,
  requestedPage: 0,
  requestId: null,
  snapshotKey: null,
  loading: false,
  loadingMore: false,
  error: null,
  nextPageError: null
}

const isCurrentRequest = (state, data) =>
  state.requestId === data.requestId && state.snapshotKey === data.snapshotKey

export const sailorAshoreVisitReports = (
  state = initialSailorAshoreVisitReportsState,
  action = {}
) => {
  const data = action.data || {}
  switch (action.type) {
    case CLEAR_SAILOR_ASHORE_VISITS:
      return { ...initialSailorAshoreVisitReportsState }
    case SEARCH_SAILOR_ASHORE_VISITS_REQUEST: {
      const firstPage = data.requestedPage === 1
      return {
        ...state,
        ...(firstPage && {
          reportItems: [],
          pageInfo: {},
          totalResults: 0,
          snapshotKey: data.snapshotKey
        }),
        requestedPage: data.requestedPage,
        requestId: data.requestId,
        loading: firstPage,
        loadingMore: !firstPage,
        error: firstPage ? null : state.error,
        nextPageError: null
      }
    }
    case SEARCH_SAILOR_ASHORE_VISITS_SUCCESS: {
      if (!isCurrentRequest(state, data)) return state
      const firstPage = data.requestedPage === 1
      const rows = get(data, 'sailorAshoreVisits', [])
      const pageInfo = get(data, 'pageInfo', {})
      return {
        ...state,
        reportItems: firstPage ? rows : [...state.reportItems, ...rows],
        pageInfo,
        totalResults: firstPage
          ? get(pageInfo, 'totalResults', 0)
          : state.totalResults,
        loading: false,
        loadingMore: false,
        error: null,
        nextPageError: null
      }
    }
    case SEARCH_SAILOR_ASHORE_VISITS_FAILURE: {
      if (!isCurrentRequest(state, data)) return state
      const firstPage = data.requestedPage === 1
      return {
        ...state,
        ...(firstPage && { reportItems: [], pageInfo: {}, totalResults: 0 }),
        loading: false,
        loadingMore: false,
        error: firstPage ? data.error : state.error,
        nextPageError: firstPage ? null : data.error
      }
    }
    default:
      return state
  }
}
